<template>
    <b-modal ref="downloadbackupmodal" :lazy="true" title="Download Backup Part Files" :centered="true" @shown="setDownloadLinks" :hide-header-close="true" no-fade>
        <div class="prompt-text">
            The Backup of the site splitted into more files you can download the part files here.
        </div>
        <div class="backup-parts">
            <div class="download-links">
                <div v-for="(downloadLink,index) in downloadLinks" :key="index" class="text-center" style="    padding: 4px;">
                    <a :href="downloadLink">Download Part - {{index+1}}</a>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <div class="d-flex align-items-center justify-content-end">
                <span class="mr-1"> Size: {{backup?backup.size:0}}</span>
                <b-btn variant="flat" @click="close">
                    cancel
                </b-btn>
                <b-btn variant="primary" @click="downloadAll">
                    Download All Files
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
import _ from "lodash";
export default {
  name: "downloadbackup",
  props: ["backup"],
  data() {
    return {
      downloadLinks: []
    };
  },
  methods: {
    setDownloadLinks() {
      this.downloadLinks = _.values(this.backup.downloadURL);
    },
    close() {
      this.$refs.downloadbackupmodal.hide();
    },
    downloadAll() {
      var timeOutForDownload = 0;
      _.forEach(this.downloadLinks, function(value, key) {
          setTimeout(function(){
            window.open(value);
          },timeOutForDownload);
          timeOutForDownload=timeOutForDownload+5000;
      });
    },
    downloadPartFile() {}
  }
};
</script>

<style scoped>
  .backup-parts{
    margin-top: 5px;
    max-height: 290px;
    overflow: scroll;
  }
</style>
